import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Printer } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const ORDENES = { fin: "Libres primero y luego por fin previsto", numero: "Número de aparato" };
const num = (d) => Number((d.nombre.match(/\d+/) || [0])[0]);
const ordenar = (list, orden) => [...list].sort((a, b) => (orden === "numero"
  ? (a.modelo || "").localeCompare(b.modelo || "") || num(a) - num(b)
  : (a.treatment ? 1 : 0) - (b.treatment ? 1 : 0) || (a.fin_prevista || "").localeCompare(b.fin_prevista || "") || (a.modelo || "").localeCompare(b.modelo || "") || num(a) - num(b)));
const titulo = (s) => (s || "").toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());
const ciclo = (n) => (n ? ` · ciclo ${n}` : "");

const Fila = ({ d, i }) => (
  <tr data-testid={`aparato-row-${i}`} className="even:bg-slate-100/70">
    <td className="border border-slate-300 px-2 py-2 text-center">{i + 1}</td>
    <td className="border border-slate-300 px-2 py-2">{titulo(d.nombre)}{d.treatment ? "" : " (libre)"}</td>
    <td className="border border-slate-300 px-2 py-2">{d.treatment ? `${titulo(d.treatment.patient?.nombre)}${ciclo(d.ciclo)}` : ""}</td>
    <td className="border border-slate-300 px-2 py-2 whitespace-nowrap">{d.treatment ? fmtDate(d.fin_prevista) : "no tiene"}</td>
    <td className="border border-slate-300 px-2 py-2">{d.siguiente ? `${titulo(d.siguiente.nombre)}${d.siguiente.centro ? ` (${titulo(d.siguiente.centro)})` : ""}${ciclo(d.siguiente.ciclo)}` : "Sin decidir"}</td>
    <td className="border border-slate-300 px-2 py-2 whitespace-nowrap">{d.siguiente?.fecha ? fmtDate(d.siguiente.fecha) : ""}</td>
  </tr>
);

export default function ImprimirAparatos() {
  const tomatis = useLocation().pathname.startsWith("/tomatis");
  const [devices, setDevices] = useState(null);
  const [orden, setOrden] = useState("fin");
  useEffect(() => {
    api.get(tomatis ? "/tomatis-devices" : "/devices").then((r) => setDevices(r.data));
  }, [tomatis]);
  const hoy = new Date().toLocaleDateString("es-ES");
  return (
    <div className="mx-auto max-w-5xl bg-white p-8 text-slate-900 print:p-0" data-testid="imprimir-aparatos-page">
      <style>{"@media print { @page { size: A4 landscape; margin: 12mm; } .no-print { display: none !important; } }"}</style>
      <div className="no-print mb-6 flex flex-wrap items-center gap-3">
        <label className="text-sm text-slate-600">Orden
          <select value={orden} onChange={(e) => setOrden(e.target.value)} data-testid="aparatos-orden" className="ml-2 rounded-md border border-slate-300 px-2 py-1.5 text-sm">
            {Object.entries(ORDENES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </label>
        <button onClick={() => window.print()} data-testid="aparatos-imprimir" className="ml-auto inline-flex items-center gap-2 rounded-md bg-[#1E3A8A] px-4 py-2 text-sm font-medium text-white"><Printer className="h-4 w-4" />Imprimir</button>
      </div>
      <h1 className="text-center font-[Outfit] text-2xl font-semibold">Control de aparatos · {tomatis ? "Tomatis" : "Syntonic"}</h1>
      <p className="mt-1 mb-4 text-sm text-slate-500">Salud y Visión · {hoy} · Ordenado por {ORDENES[orden].toLowerCase()}</p>
      {devices === null ? <p className="text-sm text-slate-400">Cargando…</p> : (
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-[#0F1E3D] text-left text-white [print-color-adjust:exact] [-webkit-print-color-adjust:exact]">
              {["Nº", "Aparato", "Paciente", "Fin previsto (entrega)", "Siguiente que lo coge", "Empieza el siguiente"].map((h) => <th key={h} className="border border-slate-300 px-2 py-2 font-semibold">{h}</th>)}
            </tr>
          </thead>
          <tbody>{ordenar(devices, orden).map((d, i) => <Fila key={d.id} d={d} i={i} />)}</tbody>
        </table>
      )}
    </div>
  );
}
